<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <InvoiceDocumentationForm
            @closeDialog="closeDialog"
            :read-only="viewOnly"
            ref="invoiceForm" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import InvoiceDocumentationForm from '@/modules/book/views/task/components/InvoiceDocumentationForm';

export default {
  name: 'InvoiceDocumentationDialog',
  components: {InvoiceDocumentationForm},
  data() {
    return {
      dialog: false,
      viewOnly: true
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.invoiceForm.cleanForm();
      this.$emit('closeDialog');
    },
    openCreationDialog(task) {
      this.dialog = true;
      this.viewOnly = false;

      let createData = {
        taskId: task.id,
        customerId: task.customer,
        signedOffer: task.signedOffer,
        file: null
      };

      this.$refs.invoiceForm.setInputData(createData);
    },
    openDialog(item) {
      this.dialog = true;
      if (!item) {
        return;
      }
      this.viewOnly = false;
      this.$refs.invoiceForm.setEditData(item);
    },
    viewDialog(item) {
      this.openDialog(item);
      this.viewOnly = true;
    }
  }
}
</script>